import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  dnsList: [],
  account:null,
  dns: null,
  error: false,
  errorStatus: null,
  success:false,
  loading: false,
  loaded:false,
  realDns:null
};
const resetDnsState = (state, action) => {
  return updateObject(state, initialState)
}
const initDnsStart = (state, action) => {
  return updateObject(state, {
    error: null,
    errorStatus: null,
    loading: true,
    loaded:false
  });
};

const setDns = (state, action) => {
  return updateObject(state, {
    realDns: action.realDns,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchDnsFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};
const changeDnsFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true,
    errorStatus: action.errorStatus
  });
};

const changeDnsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true
  });
};
const resetDnsErrorSuccess = (state, action) => {
  return updateObject(state, {
    success:false,
    error:false
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_DNS_START:
      return initDnsStart(state, action);
    case actionTypes.SET_DNS:
      return setDns(state, action);
    case actionTypes.FETCH_DNS_FAILED:
      return fetchDnsFailed(state, action);
    case actionTypes.CHANGE_DNS_SUCCESS:
      return changeDnsSuccess(state, action);
    case actionTypes.CHANGE_DNS_FAILED:
      return changeDnsFailed(state, action);
    case actionTypes.RESET_DNS_ERROR_SUCCESS:
      return resetDnsErrorSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
